/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star-btn': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" d="M14.749 6.93L11.985 9.33a.755.755 0 00-.213.662l.653 3.852a.646.646 0 01-.246.706.796.796 0 01-.847.062l-3.485-1.904a.73.73 0 00-.687 0L3.81 14.61a.797.797 0 01-.847-.062.737.737 0 01-.387-.706l.799-3.932a.754.754 0 00-.213-.662L.246 6.93a.821.821 0 01.44-1.393l3.787-.672a.74.74 0 00.563-.404L6.776.736a.8.8 0 011.442 0l1.678 3.725a.74.74 0 00.557.409l3.856.672a.805.805 0 01.645.554.822.822 0 01-.204.834h-.001z" _fill="#DADADA"/>'
  }
})
